import {
  ExerciseDeclarationServiceClient,
  ListExerciseDeclarationRequest,
  CreateExerciseDeclarationRequest,
  UpdateExerciseDeclarationRequest,
  CreateExerciseNoticeRequest,
  UpdateExerciseNoticeRequest,
  ReadExerciseDeclarationRequest,
  ReadExerciseNoticeRequest,
} from '../proto/reportpb/exercisedeclaration_grpc_web_pb';
import { notifyError } from '../components/Messages/Notification';
import { auth } from '../lib/auth/Auth';
import { objectToProtoDate, stringToProtoDate } from './ConvertService';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new ExerciseDeclarationServiceClient(
  window.env.GRPC_ENDPOINT,
  {},
  { ...auth }
);

export async function createExerciseDeclaration(param) {
  return new Promise((resolve, reject) => {
    let req = new CreateExerciseDeclarationRequest();
    req.setAccountId(param.accountId);
    req.setSubAccountNo(param.subAccountNo);
    req.setSymbol(param.symbol);
    req.setOriginalCusip(param.originalCusip);
    req.setEed(param.eed);
    req.setDned(param.dned);
    req.setSystemDate(objectToProtoDate(param.systemDate));
    service.createExerciseDeclaration(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateExerciseDeclaration(param) {
  return new Promise((resolve, reject) => {
    let req = new UpdateExerciseDeclarationRequest();
    req.setContraryId(param.contraryId);
    req.setEed(param.eed);
    req.setDned(param.dned);
    req.setSystemDate(objectToProtoDate(param.systemDate));
    req.setAccountId(param.accountId);
    req.setSymbol(param.symbol);
    req.setCorrespondent(param.correspondent);
    service.updateExerciseDeclaration(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listExerciseDeclaration(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListExerciseDeclarationRequest();
    // req.setDateType(param.dateType);
    req.setSystemDate(stringToProtoDate(param.systemDate));
    req.setAccountName(param.accountName);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setBranch(param.branch);
    req.setRep(param.rep);
    req.setBroker(param.broker);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listExerciseDeclaration(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function createExerciseNotice(param) {
  return new Promise((resolve, reject) => {
    let req = new CreateExerciseNoticeRequest();
    req.setAccountId(param.accountId);
    req.setSubAccountNo(param.subAccountNo);
    req.setSymbol(param.symbol);
    req.setOriginalCusip(param.originalCusip);
    req.setExerciseQty(param.exerciseQty);
    req.setSystemDate(objectToProtoDate(param.systemDate));
    service.createExerciseNotice(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateExerciseNotice(param) {
  return new Promise((resolve, reject) => {
    let req = new UpdateExerciseNoticeRequest();
    req.setContraryId(param.contraryId);
    req.setExerciseQty(param.exerciseQty);
    req.setSystemDate(objectToProtoDate(param.systemDate));
    req.setAccountId(param.accountId);
    req.setSymbol(param.symbol);
    req.setCorrespondent(param.correspondent);
    service.updateExerciseNotice(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readExerciseDeclaration(param) {
  return new Promise((resolve, reject) => {
    let req = new ReadExerciseDeclarationRequest();
    req.setAccountId(param.accountId);
    req.setSubAccountNo(param.subAccountNo);
    req.setSymbol(param.symbol);
    req.setOriginalCusip(param.originalCusip);
    service.readExerciseDeclaration(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readExerciseNotice(param, paging) {
  return new Promise((resolve, reject) => {
    let req = new ReadExerciseNoticeRequest();
    req.setAccountId(param.accountId);
    req.setSubAccountNo(param.subAccountNo);
    req.setSymbol(param.symbol);
    req.setOriginalCusip(param.originalCusip);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.readExerciseNotice(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
